<template>
  <a :href="href" target="_blank" rel="noopener noreferrer" class="refund-document" :class="{ 'refund-document--compact': compact }">
    <span class="refund-document__icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
        <path v-if="kind === 'receipt'" d="M8 12.5 14.5 6a3.2 3.2 0 0 1 4.5 4.5l-8.5 8.5a5 5 0 0 1-7-7L12 3.5M7 14l7-7a1.2 1.2 0 0 1 1.7 1.7L9 15.4" />
        <path v-else-if="kind === 'reference'" d="m10 13 4-4m-6 6-1 1a3.5 3.5 0 0 1-5-5l4-4a3.5 3.5 0 0 1 5 0m2 2 1-1a3.5 3.5 0 0 1 5 5l-4 4a3.5 3.5 0 0 1-5 0" />
        <template v-else><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" /><path d="M14 3v6h6M8 13h8M8 17h5" /></template>
      </svg>
    </span>
    <span class="refund-document__text"><strong>{{ label }}</strong><small v-if="description">{{ description }}</small></span>
    <svg class="refund-document__external" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M11 3h6v6M17 3l-8 8M8 4H4a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4" /></svg>
  </a>
</template>
<script>
export default {
  name: 'RefundDocumentLink',
  props: {
    href: { type: String, required: true },
    label: { type: String, required: true },
    description: { type: String, default: '' },
    kind: { type: String, default: 'invoice' },
    compact: { type: Boolean, default: false }
  }
}
</script>
<style lang="scss" scoped>
.refund-document {
  display: flex;
  align-items: center;
  gap: $ui-space-12;
  min-width: 0;
  padding: $ui-space-12;
  border: 1px solid $ui-line;
  border-radius: $ui-control-radius;
  color: $ui-blue;
  background: $ui-surface-soft;
  text-decoration: none;
  &:hover { border-color: $ui-blue; background: $ui-blue-soft; text-decoration: none; }
  &:focus-visible { outline: 2px solid $ui-blue; outline-offset: 2px; }
  &__icon { display: grid; place-items: center; flex: 0 0 36px; height: 36px; border-radius: $ui-control-radius; background: $ui-blue-soft; }
  &__icon svg { width: 20px; height: 20px; }
  &__text { display: grid; gap: $ui-space-4; flex: 1; min-width: 0; overflow-wrap: anywhere; }
  strong { font-weight: 600; font-size: $ui-font-size-body; }
  small { color: $ui-muted; font-size: $ui-font-size-metadata; line-height: 1.4; }
  &__external { width: 16px; height: 16px; flex: 0 0 16px; }
  &--compact { padding: $ui-space-8; background: $ui-surface; gap: $ui-space-8; }
  &--compact &__icon { flex-basis: 24px; height: 24px; background: transparent; }
  &--compact &__icon svg { width: 18px; height: 18px; }
}
</style>
